var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcZap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18H30.5C31.3125 18 32.0625 18.5625 32.3125 19.3125C32.625 20.125 32.4375 21 31.8125 21.5625L15.8125 35.5625C15.0625 36.125 14.0625 36.1875 13.3125 35.625C12.5625 35.125 12.25 34.125 12.625 33.25L17.4375 22H10.4375C9.625 22 8.875 21.5 8.625 20.75C8.3125 19.9375 8.5 19.0625 9.125 18.5L25.125 4.5C25.875 3.9375 26.875 3.875 27.625 4.4375C28.375 4.9375 28.6875 5.9375 28.3125 6.8125L23.5 18Z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZap);
export default __webpack_public_path__ + "static/media/ic-zap.8e827b88.svg";
export { ForwardRef as ReactComponent };